import React from 'react'
import SimpleStepNav from '../navigation/SimpleStepNav'
import InputRadioBox from '../inputs/InputRadioBox'
import InputWrapper from '../inputs/InputWrapper'
import InputDefault from '../inputs/InputDefault'
import InputColors from '../inputs/InputColors'
import useNavigationManager from '../hooks/use-navigation-manager'
import FormHeader from '../inputs/FormHeader'
import useSettingsManager from '../hooks/use-settings-manager'
import Info from '../port-image/Info'
import ValidationError from '../inputs/ValidationError'
import usePortManager from '../hooks/use-port-manager'
import InputWindows from '../inputs/InputWindows'
import OtherOptionWysisygContent from '../misc/OtherOptionWysisygContent'
import { observer } from 'mobx-react'

function PortStep () {
  const port_manager = usePortManager()
  const nav_manager = useNavigationManager()
  const settings_manager = useSettingsManager()
  const step_index = 0
  const step_name = nav_manager.getStepName(step_index)
  const strings = settings_manager.getStepSettings(step_name)

  const info = (typeof strings.image_info === 'string' && strings.image_info.length > 0) ? <Info
    text={strings.image_info}/> : null

  const isModel800 = port_manager.when('equals', [port_manager.currentPort.model, '8000'])
  return (
    <React.Fragment>
      <FormHeader htag={'h1'} strings={strings}/>

      <InputWrapper name={'model'}>
        <InputRadioBox value={'9000'} size={'half'} image={true}/>
        <InputRadioBox value={'8000'} size={'half'} image={true}/>
      </InputWrapper>

      <InputWrapper name={'size'}>
        <InputDefault type={'number'} min={200} max={600} name={'width'} size={'half'}/>
        <InputDefault
          type={'number'}
          min={isModel800 ? 295 : 200}
          max={500}
          name={'height'}
          size={'half'}
        />
        {isModel800 ? (
          <ValidationError>
            <OtherOptionWysisygContent name={'ve_8000_size'}/>
          </ValidationError>
        ) : (
          <ValidationError>
            <OtherOptionWysisygContent name={'ve_size'}/>
          </ValidationError>
        )}
      </InputWrapper>

      <InputWrapper name={'color'} grid={null}>
        <InputColors/>
        <ValidationError>
          <OtherOptionWysisygContent name={'ve_color'}/>
        </ValidationError>
      </InputWrapper>

      <InputWrapper name={'windows'}>
        <InputWindows/>
      </InputWrapper>

      <SimpleStepNav prev={false} step_name={step_name}/>
    </React.Fragment>
  )
}

export default observer(PortStep)